import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetOrgUsersCountQueryVariables = Types.Exact<{
  where: Types.Users_Bool_Exp;
}>;


export type GetOrgUsersCountQuery = { __typename?: 'query_root', users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };


export const GetOrgUsersCountDocument = gql`
    query GetOrgUsersCount($where: users_bool_exp!) {
  users_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetOrgUsersCountQuery__
 *
 * To run a query within a React component, call `useGetOrgUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgUsersCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOrgUsersCountQuery(baseOptions: Apollo.QueryHookOptions<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables> & ({ variables: GetOrgUsersCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>(GetOrgUsersCountDocument, options);
      }
export function useGetOrgUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>(GetOrgUsersCountDocument, options);
        }
// @ts-ignore
export function useGetOrgUsersCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>;
export function useGetOrgUsersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgUsersCountQuery | undefined, GetOrgUsersCountQueryVariables>;
export function useGetOrgUsersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>(GetOrgUsersCountDocument, options);
        }
export type GetOrgUsersCountQueryHookResult = ReturnType<typeof useGetOrgUsersCountQuery>;
export type GetOrgUsersCountLazyQueryHookResult = ReturnType<typeof useGetOrgUsersCountLazyQuery>;
export type GetOrgUsersCountSuspenseQueryHookResult = ReturnType<typeof useGetOrgUsersCountSuspenseQuery>;
export type GetOrgUsersCountQueryResult = Apollo.QueryResult<GetOrgUsersCountQuery, GetOrgUsersCountQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getOrgUsersCount.query.gql}
 */
export async function getOrgUsersCount(
  variables: GetOrgUsersCountQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOrgUsersCountQuery['users_aggregate']>
export async function getOrgUsersCount(
  variables: GetOrgUsersCountQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOrgUsersCountQuery>
export async function getOrgUsersCount(
  variables: GetOrgUsersCountQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOrgUsersCountQuery['users_aggregate'] | GetOrgUsersCountQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOrgUsersCountQuery>(
    GetOrgUsersCountDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users_aggregate
}